module.exports = __webpack_public_path__ + "static/media/empty-token.f90c949f.webp";